import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const homepage = process.env.HOMEPAGE || 'https://www.immobilienscout24.de/';

  return (
    <div className='margin-vertical-xl align-center'>
      <h1 className='margin-none'>{t('errorPage.heading')}</h1>
      <h5 className='margin-none'>{t('errorPage.subHeading')}</h5>
      <div>
        <img
          alt={t('errorPage.imageAlt')}
          src={t('errorPage.imageSrc')}
          onError={(event) => {
            event.currentTarget.src = t('errorPage.imageFallback');
          }}
          style={{ height: 200 }}
        />
        <p className='font-bold margin-bottom-s'>{t('errorPage.checkText')}</p>
        <ul className='list-bullet inline-block align-left margin-bottom-l'>
          <li>{t('errorPage.checkItem1')}</li>
          <li>{t('errorPage.checkItem2')}</li>
          <li>{t('errorPage.checkItem3')}</li>
        </ul>
        <p className='margin-bottom-l'>{t('errorPage.instructionText')}</p>
        <a href={homepage} className='button-primary margin-bottom-l'>
          {t('errorPage.homeButtonText')}
        </a>
        <p>{t('errorPage.thankYouText')}</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
